export const TRANSCRIPT_URLS = {
  1: 'https://raw.githubusercontent.com/fastai/course20/master/files/transcripts/transcript-1-1.json',
  2: 'https://raw.githubusercontent.com/fastai/course20/master/files/transcripts/transcript-1-2.json',
  3: 'https://raw.githubusercontent.com/fastai/course20/master/files/transcripts/transcript-1-3.json',
  4: 'https://raw.githubusercontent.com/fastai/course20/master/files/transcripts/transcript-1-4.json',
  5: 'https://raw.githubusercontent.com/fastai/course20/master/files/transcripts/transcript-1-5.json',
  6: 'https://raw.githubusercontent.com/fastai/course20/master/files/transcripts/transcript-1-6.json',
  7: 'https://raw.githubusercontent.com/fastai/course20/master/files/transcripts/transcript-1-7.json',
  8: 'https://raw.githubusercontent.com/fastai/course20/master/files/transcripts/transcript-1-8.json',
};

export const NOTES_URLS = {
  1: 'https://raw.githubusercontent.com/fastai/course20/master/files/notes/notes-1-1.md',
  2: 'https://raw.githubusercontent.com/fastai/course20/master/files/notes/notes-1-2.md',
  3: 'https://raw.githubusercontent.com/fastai/course20/master/files/notes/notes-1-3.md',
  4: 'https://raw.githubusercontent.com/fastai/course20/master/files/notes/notes-1-4.md',
  5: 'https://raw.githubusercontent.com/fastai/course20/master/files/notes/notes-1-5.md',
  6: 'https://raw.githubusercontent.com/fastai/course20/master/files/notes/notes-1-6.md',
  7: 'https://raw.githubusercontent.com/fastai/course20/master/files/notes/notes-1-7.md',
  8: 'https://raw.githubusercontent.com/fastai/course20/master/files/notes/notes-1-8.md',
}

export const VIDEO_SOURCES = {
  1: "_QUEXsHfsA0",
  2: "BvHmRx14HQ8",
  3: "5L3Ao5KuCC4",
  4: "p50s63nPq9I",
  5: "krIVOb23EH8",
  6: "cX30jxMNBUw",
  7: "VEG5xT5gAHc",
  8: "WjnwWeGjZcM",
};

export const LESSONS_NAMES = [{
  1: 'Lesson 1',
  2: 'Lesson 2',
  3: 'Lesson 3',
  4: 'Lesson 4',
  5: 'Lesson 5',
  6: 'Lesson 6',
  7: 'Lesson 7',
  8: 'Lesson 8',
}]

export const quickLinks = [
  { title: 'Course Home', href: 'https://course.fast.ai/' },
  { title: 'fast.ai', href: 'https://www.fast.ai/' },
]
